module.exports = __webpack_public_path__ + "img/2-1.ec3d5521.png";